import React from 'react'

import type { Form } from 'factorial-form'

import { observer } from 'mobx-react'

import DayPicker from 'modules/core/components/Inputs/DayPicker'
import i18n from 'modules/core/lib/i18n'

interface Props {
  form: Form
}

function TerminateDaypicker({ form }: Props) {
  return (
    <DayPicker
      label={i18n.t('employees.termination.termination_date')}
      field={form.get('terminated_on')}
      pin
      mandatory
    />
  )
}

export default observer(TerminateDaypicker)
